/**
 * Performance Section Transformers
 * Aggregates all performance-related transformers and provides section-level utilities
 */

import { transformResourcesMinification } from './resourcesMinificationTransformer';

// Re-export individual transformers
export { transformResourcesMinification } from './resourcesMinificationTransformer';

/**
 * Transforms performance-related criteria from WooRank API response
 * (minification-only for legacy parity).
 *
 * @param {Object} apiData - The SEO audit data object (already response.data from API)
 * @returns {Object} transformed performance section data
 */
export const transformPerformanceSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const resourcesMinification = transformResourcesMinification(criteria?.resources_minification);

  const allResults = [resourcesMinification];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    resourcesMinification,
  };
};


